
/**
 *      Insight web application for searching and viewing records.
 *
 *      @author Irina Patrikeeva <irina.i.ipatrikeeva@nasa.gov>
 *
 *      Created in 2015
 *      Modified on 08/27/2020
 */


/*jshint strict:false */
/*jslint nomen: true */
/*global Backbone, Handlebars, $, _, window, document, console, router, Predicates, FieldTypes */
var App = new Backbone.Marionette.Application();

App.globalState = {
  isDev: false, // Set global state variable to false for staging and production environments TODO remove
  pageSize: 10,
  currentPage: 0,
  searchFilters: '',
  currentFilters: new FilterCollection(),
  dateFilter: DateFilterKeys.all,
  filterGroups: '',
  filtersLayout: new CurrentFiltersLayoutView({ el: '#filters-collection' }),
  recordCollection: new SingleRecordCollection,
  layout: {},
  searchResults: new RecordsCollection,
  searchResultsArray: [],
  aggregations: {},
  query: "",
  eventModel: new EventCollection(),
  eventId: "",
  user: new UserModel(),
  typeFilters: '',
  fieldPredicates: new FieldPredicateCollection,
  fieldValues: [],
  success: false,
  // header and footer global app configurations
  headerParentId: 'ediHeader',
  searchButtonId: 'edi-search-button',
  footerParentId: 'edi-footer',
  helpDeskEmail: 'arc-insight-support@mail.nasa.gov',
  exportControlParentId: 'edi-export-control',
  docCookies: null,
  // searchAPIBase: '/api/search/latest',
  searchAPIBase: '/query/web/api/v1',
  queryWebBase: '/query/web/api/v1',
  version: "5.8.5",
  name: "Query Manager UI"
};

/**
 * Get aliaslist data from Query Manager API.
 * tryNumber {number} The number of times this function has been called.
 * @param tryNumber
 */
function getAliasList( tryNumber ) {

  var alias = '';

  // Call Explore Manager API
  // Then, save the alias and other data to the app global state
  // var url = '/api/search/latest?type=aliaslist&alias=backend&pagesize=100';
  var url = '/explore/api/v1/query?type=aliaslist&alias=backend&pagesize=100';

  var data = {};

  if ( url ) {

    $.ajax({
      url: url,
      data: data,
      dataType: 'json'
    })
        .done( function (response ) {

          // Save alias data to the global state of the shared styles
          if ( sharedStylesGlobals ) {

            if ( typeof saveAliasData === "function" ) {
              saveAliasData( response );
            }

            if ( sharedStylesGlobals.domain && sharedStylesGlobals.domain.Alias ) {
              alias = sharedStylesGlobals.domain.Alias;
            }
          }
          initializeUIApp( alias );
        })
        .fail(function ( jqXHR ) {
          if (console && console.log) {
            console.log( 'Failed to fetch aliaslist data, url = ' + url );
          }
          if ( tryNumber <= 5 ) {
            retry( getAliasList( tryNumber + 1 ), tryNumber + 1, 5 );
          } else {
            initializeUIApp( alias );
          }
        });
  }
}

/**
 * Initialize UI application by creating a router and setting global state for alias, cookies, etc.
 * @param alias
 */
function initializeUIApp( alias ) {

  // Set global search alias
  App.globalState.alias = alias;

  // Dynamically add project-specific style

  if ( alias ) {
    var href = "/static/" + alias + "/" + alias + ".css";
    $('head').append('<link rel="stylesheet" href="' + href + '" type="text/css" />');
  }

  // Create application router
  router = new ApplicationRouter( $( '#content' ) );
  Backbone.history.start( { pushState: true } );

  if ( ! App.globalState.isDev ) {
    // Get docCookies from shared UI styles
    if ( ediDocCookies && typeof ediDocCookies === "function" ) {
      App.globalState.docCookies = ediDocCookies();
    }

    setExportControl();
    // Get timeout and logout warnings from shared UI styles
    if ( ediTimeoutWarnings && typeof ediTimeoutWarnings === "function" ) {
      ediTimeoutWarnings('content');
    }
  }
}

/**
 * Get user of the application
 * @link UserView
 */
function getUser() {

  var user;
  if ( App && App.globalState && App.globalState.user && App.globalState.user.name === undefined ) {
    user = new UserView( App.globalState.user );
    user.getPermissions( 1 );
  }
}

/**
 * Show/hide application links in the header based on user permissions
 * @param {object} response - user permission Search API response object
 */
function processUserPermissions( response ) {
  var i,
      profileLinkEl = '#user-profile',
      nGroups = response.length - 2;

  App.globalState.user.groups = [];
  for (i = 0; i < nGroups; ++i) {
    App.globalState.user.groups.push(response[i]);
  }

  // The last two elements in the response are username and ACL_ALLOW (?) - string "anonymous"
  App.globalState.user.name = response[nGroups];

  // Set user profile link
  if (App.globalState.user.name) {
    $(profileLinkEl).attr('href', '/cloudrepo/user/' + App.globalState.user.name);
  } else {
    $(profileLinkEl).hide();
  }
}

/**
 * Attach spinner icon (loading) to the parent element and render it in the DOM.
 * @param parentId  {string} ID attribute of the parent element.
 * @param iconId {string} ID attribute of the spinner icon.
 * @param text {*} Optional text to to display.
 */
function showLoadingIcon( parentId, iconId, text )  {

  var iconSpan,
      iconElement,
      icon;

  if ( iconId ) {
    // check if loading icon ID starts with '#'
    if ( iconId.substr( 0, 1 ) !== "#" ) {
      icon = $( '#' + iconId );
    } else {
      icon = $( iconId );
    }
    // check if the loading icon exists
    if ( icon && icon.length === 0 ) {

      iconSpan = document.createElement("span");
      iconSpan.setAttribute( "id", iconId );
      iconSpan.setAttribute( "class", "loading-icon")
      addDOMElement( iconSpan, parentId );

      iconElement = document.createElement("i");
      iconElement.setAttribute( "class", "fa fa-spinner" );
      if ( text ) {
        $(iconElement).text( text );
      }
      addDOMElement( iconElement, iconId );
    }
  }
}

/**
 * Hide loading icon from display.
 * @param id {string} Loading icon element id.
 */
function hideLoadingIcon( id ) {

  if ( id ) {
    var element = $('#' + id);
    if ( element ) {
      element.hide();
    }
  }
}

/**
 * Render a part of the page inside a parent element.
 * @param data {string} HTML string of the contents to display.
 * @param id {string} Parent element id.
 */
function renderPageRegion( data, id ) {
  //console.log(data, id)
  if ( data && id ) {
    // Parent div where all the content is rendered
    var content = $( '#' + id );
    if ( content ) {
      content.empty().append( data );
    }
  }

  x = -1;
  lastName = "";
  if (id === "tree_viewers-content") {
    $("#graph-region .panel-heading h4").each(function () {
      x++
      //console.log($(this).text())
      let curName = $(this).text().replace("Collapse panelExpand panel", "")
      //console.log(curName)
      if($("#tree_viewers-sidebar-" + curName).length) {
        console.log("already exists", $("#tree_viewers-sidebar-" + curName))
      } else {
        $('<a id="tree_viewers-sidebar-' + curName.replace(
            / |\//g, "_") + '" class="w3-bar-item" href="#panel-' + x + '-header" title="' + curName.replace(
            / |\//g, "_") + '"> ' + curName + '</a>').insertAfter(
            "#tree_viewers-sidebar" + lastName.replace(
            / |\//g, "_"))
        //console.log($(this).attr("name"), lastName)
        lastName = "-" + curName
      }
    })
  }
  x = -1;
  lastName = "";
  console.log('id: ', id );
  if (id === "panels-content") {
    $("#panels-region .panel-heading").each(function () {
      x++
      console.log($(this));
      let curName = $(this).attr("name")
      if ($("#panels-region" + curName).length) {
        console.log("already exists", $("#panels-region" + curName))
      } else {
        $('<a id="panels-sidebar-' + curName.replace(
            / |\//g, "_") + '" class="w3-bar-item" href="#panel-' + x + '-header" title="' + curName.replace(
            / |\//g, "_") + '"> ' + curName + '</a>').insertAfter(
            "#panels-sidebar" + lastName.replace(
            / |\//g, "_"))
        //console.log($(this).attr("name"), lastName)
        lastName = "-" + curName
      }
    })
  }
  // $(".menu-links a").css("padding", "0px 8px")                   // ===== testing removal as this is already set in the css
  $(".panel-body").css("background-color", "white")
  $("#panels-region .panel-wrapper .panel-default").css("background-color", "white")
}

/**
 * Remove a part of the page inside a parent element.
 * @param id {string} Parent element ID.
 */
function removePageContent( id ) {
  if ( id ) {
    var content = $( '#' + id );
    if ( content ) {
      content.empty();
    }
  }
}

/**
 * Load skeleton HTML while aggregations are loading.
 * @param parentId {string} Element DOM ID that contains aggregations.
 * @param iconId {string} Unique element ID for the aggregations image.
 * @param url {string} URL of the image to display.
 */
function loadSkeletonImage( parentId, iconId, url ) {

  var iconSpan,
      iconElement,
      icon;

  if ( iconId ) {
    // check if loading icon ID starts with '#'
    if ( iconId.substr( 0, 1 ) !== "#" ) {
      icon = $( '#' + iconId );
    } else {
      icon = $( iconId );
    }
    // check if the loading icon exists
    if ( icon && icon.length === 0 ) {

      iconSpan = document.createElement("div");
      iconSpan.setAttribute( "id", iconId );
      iconSpan.setAttribute( "class", "loading-skeleton")
      addDOMElement( iconSpan, parentId );

      iconElement = document.createElement("img");
      iconElement.setAttribute( "src", url );

      addDOMElement( iconElement, iconId );
    }
  }
}

/**
 * TODO: remove unused templates, functions, etc.
 */
/**
 *  Show single record view page
 *  @param titleLink {object} - title link event target object
 */
function showSingleRecordView( titleLink ) {
  var id,
      type,
      url,
      alias;

  if ( titleLink ) {

    // reset single record collection
    App.globalState.recordCollection.reset( null );

    // Get id and type from titleLink attributes
    id = $( titleLink ).attr("id");
    type = $( titleLink ).attr("type");

    if ( id && type ) {
      url = "view/";
      alias = App.globalState.alias;
      if ( alias ) {
        url += alias + "/";
      }
      url += type + "/" + id;
    }


    // Per JIRA USRA-604, set global graph collapse flag to true
    App.globalState.collapse = true;

    if ( url ) {
      router.navigate( url, { trigger: true } );
    }
  }
}

/** Display a bar chart for one type of document ***/
function displayDocumentChart(title, id, region, data, keys) {
  var chart = {},
      chartsString = '[{ "buckets": [',
      chartView,
      i;
  for (i = 0; i < data.length - 1; ++i) {
    chartsString += '{ "doc_count" : ' + data[i].toString() + ', "key":"' + keys[i] + '"},';
  }
  chartsString += '{ "doc_count" : ' + data[i].toString() + ', "key":"' + keys[i] + '"}]}]';
  chart.titles = [title];
  chart.ids = [id];

  chart.charts = JSON.parse(chartsString);
  chartView = new ChartsLayoutView(chart);
  region.show(chartView);
}

/*** Display a chart for all documents
 * @type is a type of document, e.g. EC, FIAR, etc.
 * @data is an array of data values to graph
 * @keys is an array of data keys, e.g. open, closed, etc.
 * @layout is Backbone layout to render the chart at
 * ***/
function showDocumentChart(type, data, keys, layout) {

  switch (type.toLowerCase()) {
    case "dr":
      displayDocumentChart('Discrepancy Report (DR)', 'dr-chart', layout.drRegion, data, keys);
      break;
    case "ec":
      displayDocumentChart('Engineering Change (EC)', 'ec-chart', layout.ecRegion, data, keys);
      break;
    case "fab":
      displayDocumentChart('Fabrication Action Breakdown (FAB)', 'fab-chart', layout.fabRegion, data, keys);
      break;
    case "fiar":
      displayDocumentChart('Failure Investigation Action Report (FIAR)', 'fiar-chart', layout.fiarRegion, data, keys);
      break;
    case "od":
      displayDocumentChart('Other Documents (OD)', 'od-chart', layout.odRegion, data, keys);
      break;
    case "odt":
      displayDocumentChart('Over Due Tags (ODT)', 'odt-chart', layout.odtRegion, data, keys);
      break;
    case "tps":
      displayDocumentChart('Task Preparation Sheet (TPS)', 'tps-chart', layout.tpsRegion, data, keys);
      break;
    case "waiver":
      displayDocumentChart('Waiver (WAIVER)', 'wvr-chart', layout.wvrRegion, data, keys);
      break;
    case "ytn":
      displayDocumentChart('Yellow Tag Notice (YTN)', 'ytn-chart', layout.ytnRegion, data, keys);
      break;
    default:
      break;
  }
}

/*** Add CSS class to panel based on the number of open/closed paperwork items in the Dashboard ***/
function colorCodePanel(type, data) {
  var region = $('#' + type.toLowerCase() + '-region'),
      panel,
      open,
      closed,
      title;
  if (region.length > 0) {
    panel = $(region[0]).find('.panel');
    if (panel.length > 0) {
      open = data[0];
      closed = data[1];

      if (open > 0) {
        if (closed > 0) {
          panel.addClass('open-closed');
        } else {
          panel.addClass('open-no-closed');
        }
        title = $(panel[0]).find('a.title-link');
        if (title.length > 0) {
          title[0].innerHTML = '<i class="fa fa-exclamation-triangle"></i>' + title[0].innerHTML;
        }
      } else {
        if (closed > 0) {
          panel.addClass('no-open-closed');
        } else {
          panel.addClass('no-open-no-closed');
        }
      }
    }
  }
}

/*** Process server response for event documents ***/
/*global EventInfoView, DocumentsChartsLayoutView */
function processEventDocuments(response) {
  var keys = ['Open', 'Closed'],
      eventModel = new EventModel(),
      eventLayout,
      chartsLayout,
      data,
      counts,
      k;
  for (k in response.event) {
    if (response.event.hasOwnProperty(k)) {
      eventModel.set(k, response.event[k]);
    }
  }

  eventLayout = new EventInfoView({model: eventModel});
  App.globalState.layout.eventRegion.show(eventLayout);

  chartsLayout = new DocumentsChartsLayoutView();
  App.globalState.layout.resultsRegion.show(chartsLayout);

  for (k in response) {
    if (response.hasOwnProperty(k) && k !== "event") {
      data = response[k];
      counts = [data.open, data.total - data.open];
      showDocumentChart(k, counts, keys, chartsLayout);
      colorCodePanel(k, counts);
    }
  }
}

/*** Display a list of documents
 * @records is documents to display
 * @status is status of documents (open or closed)
 * @type is type of ducuments
 * @summaryRegion is Backbone region to render the collection summary to
 * @docsRegion is Backbone region to render doument snippets to
 * ***/
/*global DocumentsSummaryView, DocumentsSummaryModel, DocumentsResultsLayoutView, RecordsListView */


/*** Display open and closed documents
 * open is all open documents for an event
 * closed is all closed documents for an event
 * type is document type, e.g. EC, FIAR, etc.
 * ***/
function processDocumentsResponse(open, closed, type) {
  var nPixels = 45;
  App.globalState.layout = new DocumentsResultsLayoutView({el: '#results-region'});
  App.globalState.layout.render();
  displayDocuments(open, "open", type, App.globalState.layout.summaryRegionOpen, App.globalState.layout.resultsRegionOpen);
  displayDocuments(closed, "closed", type, App.globalState.layout.summaryRegionClosed, App.globalState.layout.resultsRegionClosed);

  // /* Clamp text longer than 45px (or 2 lines) */
  // $('.subtitle').dotdotdot({
  //     height: nPixels
  // });
}

/*** Capitalize the first letter of a word ***/
String.prototype.capitalizeFirstLetter = function () {
  return this.charAt(0).toUpperCase() + this.slice(1);
};

/*** Override template compilation ***/

/* From Backbone.Marionette documentation: the default template compilation passes the results
 from loadTemplate to the compileTemplate function, which returns an underscore.js compiled
 template function. When overriding compileTemplate remember that it must return a function
 which takes an object of parameters and values and returns a formatted HTML string.

 http://marionettejs.com/docs/marionette.templatecache.html#override-template-compilation
 ***/
Backbone.Marionette.TemplateCache.prototype.compileTemplate = function (rawTemplate, options) {
  // use Handlebars.js to compile the template
  return Handlebars.compile(rawTemplate);
};

/**
 * Initialize shared EDI export control warning
 */
function setExportControl() {
  var exportControlParentId = App.globalState.exportControlParentId;
  // Call shared UI export control warning
  ediExportControlWarning(exportControlParentId);
}

/**
 * Listen for DOM changes and call the callback function when element with className is attached
 * @param {string} className - class name of the target element
 * @param {function} callBack - function to call when element is attached
 * @returns {MutationObserver}
 */
function getMutationObserver(className, callBack) {
  return new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {

      if (mutation.addedNodes && mutation.addedNodes.length > 0) {
        // element added to DOM
        var hasClass = [].some.call(mutation.addedNodes, function(el) {
          if (el.classList) {
            return el.classList.contains(className);
          } else {
            return false;
          }
        });
        if (hasClass) {
          // element has class 'className'
          if ( callBack ) {
            callBack();
          }

        }
      }
    });
  });
}

/**
 * Try calling an input function again, if the number of tries have not exceeding the maximum number of tries.
 * @param functionToCall {function} Function to call.
 * @param tryNumber {number} Number of times the function has been called.
 * @param maxTries {number} Maximum number of times the function will be called.
 */
function retry( functionToCall, tryNumber, maxTries ) {
  if ( tryNumber <= maxTries && typeof functionToCall === "function" ) {
    (functionToCall)();
  }
}